
import ModalV3 from "@/app/ui/components/modal/modal-v3.vue";
import { Options, Vue, prop } from "vue-class-component";
import Checkbox from "primevue/checkbox";
import { KulionerMerchant } from "@/domain/entities/Kulioner";
import formatPriceRP from "@/app/infrastructures/misc/common-library/FormatPriceRP";
import { computeKulionerTotals } from "@/app/ui/views/kulioner/utils/totals";
import SummaryCard from "@/app/ui/views/kulioner/components/summary-card.vue";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean
  });
  merchants = prop<KulionerMerchant[]>({
    default: () => [],
    type: Array
  });
}

@Options({
  components: {
    ModalV3,
    Checkbox,
    SummaryCard
  },
  emits: ["close", "confirm"]
})
export default class ModalProcessOrder extends Vue.with(Props) {
  isDisabled = false;
  isCheck = false;
  // Compute all totals once to avoid repeated traversals
  get computedTotals() {
    return computeKulionerTotals(this.merchants);
  }

  get totalMerchantCompleted() {
    return this.computedTotals.totalMerchantCompleted;
  }

  get totalMerchant() {
    return this.computedTotals.totalMerchant;
  }

  get totalProduct() {
    return this.computedTotals.totalProduct;
  }

  get totalProductCompleted() {
    return this.computedTotals.totalProductCompleted;
  }

  get totalPieces() {
    return this.getTotalPieces();
  }

  get totalActualPieces() {
    return this.getTotalPieces(true);
  }

  // price multiple by quantity
  get totalTransaction() {
    return this.getTotalTransaction();
  }

  // price multiply by actual quantity
  get totalTransactionCompleted() {
    return this.getTotalTransaction(true);
  }

  getTotalTransaction(isCompleted = false) {
    const total = isCompleted
      ? this.computedTotals.totalTransactionCompleted
      : this.computedTotals.totalTransaction;
    return formatPriceRP(total);
  }

  getTotalPieces(isCompleted = false) {
    return isCompleted
      ? this.computedTotals.totalActualPieces
      : this.computedTotals.totalPieces;
  }

  close() {
    this.$emit("close");
  }
  confirm() {
    this.$emit("confirm");
  }
}
